export const DIVIDER_VARIANT = {
  space: 'space',
  dot: 'dot',
  line: 'line',
  separator: 'separator',
} as const
